import app from 'flarum/forum/app';
import addRegistrationTerms from './addRegistrationTerms';
import addRegistrationFields from './addRegistrationFields';
import addProfileSettings from './addProfileSettings';
import addProfileDisplay from './addProfileDisplay';
import addLogInThrottleMessage from './addLogInThrottleMessage';
import addMemberList from './addMemberList';
import addMembersMenu from './addMembersMenu';
import addLogInMenu from './addLogInMenu';
export { default as extend } from './extend';
app.initializers.add('champis-users', () => {
  addRegistrationTerms();
  addRegistrationFields();
  addProfileSettings();
  addProfileDisplay();
  addLogInThrottleMessage();
  addMemberList();
  addMembersMenu();
  addLogInMenu();
});